import React, { useRef } from 'react';

const ScrollContainer = ({ children, heightMultiplier = 0.6975, overflowX = 'hidden', overflowY = 'scroll' }) => {
    const windowSize = useRef([window.innerWidth, window.innerHeight]);
    const windowHeight = Math.round(windowSize.current[1] * heightMultiplier);

    return (
        <div style={{ overflowX: overflowX, overflowY: overflowY, height: `${windowHeight}px` }}>
            {children}
        </div>
    );
};

export default ScrollContainer;